import BaseComponent from "../../../../lib/components/BaseComponent";
import LoginForm from "./login/LoginForm";
import logoTeil from "./img/logo-cner-teil-color.png";
import CM from "../../../model/system/CM";
import cner_config from "../../../../cner.config";

class LandingLogin extends BaseComponent {

  render() {
    if (CM.get().getToken() == null) {
      return <>
        <div className={cner_config[CM.get().developer].cner_bg_img_class + ' bg-cover bg-center bg-no-repeat fixed inset-0'}/>
        <LoginForm/>
        <img src={logoTeil} alt='Teil' className=" bottom-[-60px] left-[-60px] lg:h-[480px] md:h-[380px] h-[280px] hidden md:block relative md:fixed"/>
      </>
    } else {
      window.location.href = '/cner';
      return <></>
    }
  }
}

export default LandingLogin;
